var React = require('react');

function CloseAlt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.090772 0.88552L0.991611 0L10 8.8552L9.09916 9.74072L0.090772 0.88552Z","fill":"#222222","key":0}),React.createElement("path",{"d":"M9.00839 0.259277L9.90923 1.1448L0.900839 10L0 9.11448L9.00839 0.259277Z","fill":"#222222","key":1})]);
}

CloseAlt.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = CloseAlt;

CloseAlt.default = CloseAlt;
